// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__kAXQY","loader":"Loader_loader__ChRMX","lds-dual-ring":"Loader_lds-dual-ring__D3+yC"};